import React from "react";
import InstallSection from "../../InstallSection";
import DeliverySection from "../../DeliverySection";
import MiscSection from "../../MiscSection";
import PricingFactorsSection from "../../PricingFactorsSection";
import FormInput from "../../FormInput";
import FormSelect from "../../FormSelect";

/**
 * Job-level costs: the money that belongs to the job rather than to any one
 * line — installation, delivery, miscellaneous, material financing — plus the
 * pricing factors that turn cost into a quote.
 *
 * It is reached from the rail like any other row, because in the cost trace
 * these are line items of the job: the job-scope trace shows Installation,
 * Delivery and Miscellaneous by name, and this is where they are typed.
 */

function JobCostsEditor({ formData, dispatch }) {
  return (
    <div className="est-editor">
      <div className="est-editor__hd">
        <div>
          <p className="wb-eyebrow">Job level</p>
          <h1 className="wb-h1">Delivery, install &amp; extras</h1>
          <p className="wb-sub">
            These costs sit outside any single line. They are reported
            separately in the trace, and they carry overhead and profit like
            every other cost.
          </p>
        </div>
      </div>

      <fieldset className="est-fieldset">
        <legend>Material financing</legend>
        <div className="est-legacy-fields">
          <FormInput
            label="Material Origination Cost"
            field="material_origination_cost"
            value={formData.material_origination_cost}
            dispatch={dispatch}
            type="number"
            step="0.5"
          />
          <FormInput
            label="Material Financing %"
            field="material_financing_percent"
            value={formData.material_financing_percent}
            dispatch={dispatch}
            type="number"
            step="0.5"
          />
        </div>
      </fieldset>

      <div className="est-legacy-fields">
        <InstallSection
          formData={formData}
          dispatch={dispatch}
          FormInput={FormInput}
        />
        <DeliverySection
          formData={formData}
          dispatch={dispatch}
          FormInput={FormInput}
        />
        <MiscSection
          miscItems={formData.misc_items}
          fixedCosts={{
            equipment_rental_cost: formData.equipment_rental_cost,
            hardware_costs: formData.hardware_costs,
            powder_coating_costs: formData.powder_coating_costs,
            fasteners_screws_costs: formData.fasteners_screws_costs,
          }}
          dispatch={dispatch}
          FormInput={FormInput}
        />
        <PricingFactorsSection
          formData={formData}
          dispatch={dispatch}
          FormInput={FormInput}
          FormSelect={FormSelect}
        />
      </div>
    </div>
  );
}

export default JobCostsEditor;
